import {
  MapPin,
  Hash,
  Database,
  Globe,
  Building2,
  FileSpreadsheet,
  ShoppingBag,
} from 'lucide-react';
import type { ElementType } from 'react';

/**
 * Static map of category slug/icon-name → Lucide component.
 * Add entries here when new categories are created in admin.
 * This avoids importing the entire `icons` object from lucide-react (~200 KiB).
 */
export const categoryIcons: Record<string, ElementType> = {
  // by slug
  addresses: MapPin,
  postalCodes: Hash,
  geographicData: Globe,
  companies: Building2,
  customData: Database,
  // by lucide icon name (stored in categories.icon column)
  MapPin,
  Hash,
  Database,
  Globe,
  Building2,
  FileSpreadsheet,
  ShoppingBag,
};

export function getCategoryIcon(nameOrSlug: string | null | undefined, fallback: ElementType = ShoppingBag): ElementType {
  if (!nameOrSlug) return fallback;
  return categoryIcons[nameOrSlug] || fallback;
}
